import BigNumber from './layout/bigNumber';
import Fact from './layout/fact';
import Wrapper from './layout/wrapper';
import React from 'react';

const formatMwParts = value => {
  const rounded = String(Math.round(Number(value || 0)));
  const parts = [];

  for (let i = rounded.length; i > 0; i -= 3) {
    parts.unshift(rounded.slice(Math.max(i - 3, 0), i));
  }

  return parts;
};

const PowerFact = ({ title, value, label }) => (
  <Fact>
    <h4>
      {title}
    </h4>
    <BigNumber>
      <h1>
        {formatMwParts(value).map((part, index) => (
          <React.Fragment key={`${part}-${index}`}>
            {index > 0 && '.'}
            {part}
          </React.Fragment>
        ))}
      </h1>
      <label>{label}</label>
    </BigNumber>
  </Fact>
);

const Potencia = ({ año, kpiDict }) => {
  const baseYear = kpiDict["potencia_instalada_base_year"];

  return (
    <Wrapper>
      <div>
        <PowerFact
          title="La potencia instalada en energía solar fotovoltaica es:"
          value={kpiDict["potencia_instalada_solar_fv"]}
          label={` MW en el año ${año}.`}
        />
        <PowerFact
          title="La potencia instalada en energía eólica es:"
          value={kpiDict["potencia_instalada_eolica"]}
          label={` MW en el año ${año}.`}
        />
        <PowerFact
          title="La potencia instalada en sistema de almacenamiento es:"
          value={kpiDict["potencia_instalada_almacenamiento"]}
          label={` MW en el año ${año}.`}
        />
      </div>
      <div>
        <PowerFact
          title={`Aumento de potencia instalada en energía solar fotovoltaica respecto de ${baseYear}:`}
          value={kpiDict["potencia_instalada_incremento_solar_fv"]}
          label={` MW entre ${baseYear} y ${año}.`}
        />
        <PowerFact
          title={`Aumento de potencia instalada en energía eólica respecto de ${baseYear}:`}
          value={kpiDict["potencia_instalada_incremento_eolica"]}
          label={` MW entre ${baseYear} y ${año}.`}
        />
        <PowerFact
          title={`Aumento de potencia instalada en sistema de almacenamiento respecto de ${baseYear}:`}
          value={kpiDict["potencia_instalada_incremento_almacenamiento"]}
          label={` MW entre ${baseYear} y ${año}.`}
        />
      </div>
    </Wrapper>
  );
};

export default Potencia;
